import { useState } from "react";

/** D.5: Tenant-facing audit log — who did what, when (from CQRS domain_records) */

interface AuditEntry {
  id: string;
  actorName: string;
  actorType: "user" | "system" | "automation" | "api" | "import";
  action: string;
  entityType: string;
  entityId: string;
  detail: string;
  createdAt: string;
}

export default function AuditLogPage() {
  const [entries] = useState<AuditEntry[]>([]);
  const [filterUser, setFilterUser] = useState("");
  const [filterEntity, setFilterEntity] = useState("all");

  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-foreground">Audit Log</h2>
        <p className="text-sm text-muted-foreground">Activity history for compliance and transparency</p>
      </div>

      <div className="flex gap-3">
        <input type="text" value={filterUser} onChange={(e) => setFilterUser(e.target.value)}
          placeholder="Filter by user..."
          className="flex-1 rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground" />
        <select value={filterEntity} onChange={(e) => setFilterEntity(e.target.value)}
          className="rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground">
          <option value="all">All entities</option>
          <option value="contact">Contacts</option>
          <option value="deal">Deals</option>
          <option value="page">Pages</option>
          <option value="campaign">Campaigns</option>
          <option value="workflow">Workflows</option>
          <option value="booking">Bookings</option>
        </select>
      </div>

      {entries.length === 0 ? (
        <div className="rounded-md border border-border p-12 text-center">
          <span className="text-5xl">📜</span>
          <p className="mt-4 font-medium text-foreground">No activity recorded yet</p>
          <p className="mt-1 text-sm text-muted-foreground">
            All actions on your account will be logged here automatically via the CQRS event system.
          </p>
        </div>
      ) : (
        <div className="space-y-2">
          {entries.map((entry) => (
            <div key={entry.id} className="rounded-md border border-border p-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className={`h-2 w-2 rounded-full ${
                    entry.actorType === "user" ? "bg-[var(--color-primary)]" :
                    entry.actorType === "automation" ? "bg-[var(--color-secondary)]" :
                    entry.actorType === "system" ? "bg-[var(--color-muted-foreground)]" :
                    "bg-[var(--color-success)]/50"
                  }`} />
                  <span className="text-sm font-medium text-foreground">{entry.actorName}</span>
                  <span className="text-sm text-muted-foreground">{entry.action}</span>
                  <span className="text-sm text-foreground">{entry.entityType}</span>
                </div>
                <span className="text-xs text-muted-foreground">{entry.createdAt}</span>
              </div>
              {entry.detail && (
                <p className="mt-1 ml-4 text-xs text-muted-foreground">{entry.detail}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
